import { API_URL_WHALESHARK_GLANCE } from "@constants/Clients/whaleshark/whaleshark.env";
import apiInstance from "@services/Shared/instanceAxios";

const getItems = () =>
  apiInstance({
    url: API_URL_WHALESHARK_GLANCE,
    params: {
      order: "desc",
      sort: "createdAt",
    },
  });

export default getItems;
